import { render, staticRenderFns } from "./Doner.vue?vue&type=template&id=23e90b81"
import script from "./Doner.vue?vue&type=script&lang=js"
export * from "./Doner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports